import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

//选Same As Property Address时给Address赋值当前job的Property的值
export function setSameAsPropertyAddress({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter) {
    formComponent.formRef.current?.setFieldValue('PptStreetNumber', pageComponent.state.jobData.PptStreetNumber);
    formComponent.formRef.current?.setFieldValue('PptStreetName', pageComponent.state.jobData.PptStreetName);
    formComponent.formRef.current?.setFieldValue('PptSuburb', pageComponent.state.jobData.PptSuburb);
    formComponent.formRef.current?.setFieldValue('PptState', pageComponent.state.jobData.PptState);
    formComponent.formRef.current?.setFieldValue('PptPostcode', pageComponent.state.jobData.PptPostcode);
    formComponent.formRef.current?.setFieldValue('PptLot', pageComponent.state.jobData.PptLot);
    formComponent.formRef.current?.setFieldValue('PptLpps', pageComponent.state.jobData.PptLpps);
    formComponent.formRef.current?.setFieldValue('PptVolume', pageComponent.state.jobData.PptVolume);
    formComponent.formRef.current?.setFieldValue('PptFolio', pageComponent.state.jobData.PptFolio);
    formComponent.formRef.current?.setFieldValue('PptSection', pageComponent.state.jobData.PptSection);
    formComponent.formRef.current?.setFieldValue('PptCounty', pageComponent.state.jobData.PptCounty);
    formComponent.formRef.current?.setFieldValue('PptCrownAllotment', pageComponent.state.jobData.PptCrownAllotment);
    formComponent.formRef.current?.setFieldValue('PptParish', pageComponent.state.jobData.PptParish);
  } else {
    formComponent.formRef.current?.setFieldValue('PptStreetNumber', '');
    formComponent.formRef.current?.setFieldValue('PptStreetName', '');
    formComponent.formRef.current?.setFieldValue('PptSuburb', '');
    formComponent.formRef.current?.setFieldValue('PptState', '');
    formComponent.formRef.current?.setFieldValue('PptPostcode', '');
    formComponent.formRef.current?.setFieldValue('PptLot', '');
    formComponent.formRef.current?.setFieldValue('PptLpps', '');
    formComponent.formRef.current?.setFieldValue('PptVolume', '');
    formComponent.formRef.current?.setFieldValue('PptFolio', '');
    formComponent.formRef.current?.setFieldValue('PptSection', '');
    formComponent.formRef.current?.setFieldValue('PptCounty', '');
    formComponent.formRef.current?.setFieldValue('PptParish', '');
  }
}

//Suburb控件 根据输入关键字找自动完成的 Suburb 和 Postcode 数据源
export function searchSuburbChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    //优先取表单已选的州, 没有则回退到模块默认州
    let state = formComponent.formRef.current?.getFieldValue('PptState');
    if (state === null || state === undefined) {
      state = pageComponent.state.jobData.ModuleConfig.DefaultState;
    }
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + parameter + '&state=' + state)
      .then(({ data }) => {
        let options = [];
        if (data.result) {
          //下拉项展示 "Suburb (Postcode)", data 里带完整 suburb 对象供选择后回填
          data.data.map((suburb, j) => {
            options.push({ label: suburb.Name + ' (' + suburb.Postcode + ')', value: suburb.Name + ' (' + suburb.Postcode + ')', data: suburb });
          })
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = options;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//Suburb 选择后自动回填 Suburb 与 Postcode
export function searchSuburbSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldsValue({ PptSuburb: data.data.Name, PptPostcode: data.data.Postcode });
}

//弹出mailmerge的div
export function docMergeAdjoiningProperty({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ mailMergeTemplateShow: true, mailMergeObjId: parameter.AdjoiningPropertyId, mailMergeObj: parameter, dataModelType: 5 });
  setTimeout(() => {
    pageComponent.mailMergeTemplate.current?.getMailMergeTemplate(5, parameter.AdjoiningPropertyId);
  }, config.setTimeoutMilliSecond);
}

//PwnTrigger控件找自动数据源
export function searchPwnTriggerChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  console.log(pageComponent);
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + parameter)
      .then(({ data }) => {
        let options = [];
        if (data.result) {
          data.data.map((item, j) => {
            options.push({ label: item.Name, value: item.Name, data: item });
          })
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = options;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//PwnTrigger选择后快速填写数据
export function searchPwnTriggerSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldValue('PwnTrigger', data.data.Name);
}

//HowPwnServed控件找自动数据源
export function searchHowPwnServedChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  console.log(pageComponent);
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + parameter)
      .then(({ data }) => {
        let options = [];
        if (data.result) {
          data.data.map((item, j) => {
            options.push({ label: item.Name, value: item.Name, data: item });
          })
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = options;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//PwnTrigger选择后快速填写数据
export function searchHowPwnServedSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldValue('HowPwnServed', data.data.Name);
}

export function showPwnTriggerOptionsDiv({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  console.log('showPwnTriggerOptionsDiv called', pageComponent);
  pageComponent.setState({ pwnTriggerOptionsShow: true });
}
